interface CategoryIllustrationProps {
  src: string;
  className?: string;
}

/** Category card illustration */
export default function CategoryIllustration({
  src,
  className = "",
}: CategoryIllustrationProps) {
  return (
    <img src={src} alt="" className={className} aria-hidden />
  );
}
